import { Link } from 'react-router-dom';

export default function About() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div className="space-y-6">
            <p className="text-xs tracking-[0.3em] text-[#C0392B] uppercase">Our Story</p>
            <h2 className="text-4xl md:text-5xl font-light text-[#2D2D2D] leading-tight">
              Experience the Best of Modern Chinese Cuisine
            </h2>
            <div className="w-12 h-0.5 bg-[#C0392B]"></div>
            <p className="text-base text-[#666666] leading-relaxed">
              At Yummy Lab, we are dedicated to providing our customers with the most delicious and authentic Asian cuisine.
            </p>
            <p className="text-base text-[#666666] leading-relaxed">
              From our selection of mouth-watering hot pot and hand-pulled noodle dishes to our BBQ selections, every dish is made with love and care.
            </p>
            <Link to="/menu" className="mt-8 px-10 py-4 bg-[#C0392B] text-white text-sm tracking-wider hover:bg-[#A93226] transition-all duration-300 whitespace-nowrap cursor-pointer rounded-sm inline-block">
              Menu
            </Link>
          </div>

          <div className="relative h-[600px]">
            <img 
              src="https://static.readdy.ai/image/356e0a32a00e968a1405b9eb797d2bd9/7ca7067a57cb2d379f5bf004609e05c7.jpeg"
              alt="Chef with Fire"
              className="w-full h-full object-cover object-top rounded-sm"
            />
            <div className="absolute -bottom-6 -left-6 w-48 h-48 bg-[#C0392B]/8 rounded-sm -z-10"></div>
          </div>
        </div>
      </div>
    </section>
  );
}
